import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditLeadOwnerMain = (props) => {
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState(0);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data.filter((el) => el.sprzedaz === "1"));
        createUserOptions(data);
        fetchLeads();
      })
      .catch((error) => {});
  };

  const createUserOptions = (data) => {
    var courtsOptions = [];
    data.map((el) => {
      courtsOptions.push({ label: el.name, value: el.name });
    });
    setUserOptions(courtsOptions);
  };

  const fetchLeads = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: leadId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getLeadId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body2),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var body = {
            leadId: value2,
            leadName: data[0].name,
            field: "owner",
            value: value,
          };

          await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {
              emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
              var templateParams = {
                to: banks.filter((el) => el.name === value)[0].mail,
                reply_to: props.uData.mail,
                user: props.uData.name,
                id: value2,
                subject:
                  "Nowy kontakt - " +
                  leads.filter((el) => el.id === value2)[0].name,
                user_name: props.user,
              };

              emailjs.send("KPPP", "template_5knm55c", templateParams).then(
                function (response) {
                  props.logClientAction(
                    "Edytowano opiekuna leada: " + props.user,
                    value2
                  );

                  MySwal.fire({
                    icon: "success",
                    title: "Edytowano",
                    text: "lead",
                  }).then(async (result) => {
                    props.close();
                  });
                },
                function (error) {}
              );
            })
            .catch((error) => {});
        });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0 && value2 > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Kontakt <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={value2}
                onChange={(e) => {
                  setValue2(e.target.value);
                }}
              >
                {!value2 ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                {leads.map((el) => (
                  <>
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  </>
                ))}
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Opiekun kontaktu <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={userOptions}
                defaultValue={{ label: value, value: value }}
                value={{ label: value, value: value }}
                onChange={(e) => {
                  setValue(e.value);
                }}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadOwnerMain;
